import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignupComponent } from './signin/app.signup.component';
import { CardComponent } from './card/app.card.component';
import { ProfileComponent } from './profile.component';
import { HomeComponent } from './app.home.component';
import { AboutComponent } from './app.about.component';



// Route Configuration
export const routes: Routes = [{
  path: '',
  redirectTo: '/home/cards',
  pathMatch: 'full'
},
{
  path: 'home', component: HomeComponent, children: [{ path: 'cards', component: CardComponent },
  { path: 'profile', component: ProfileComponent }]
},

   { path: 'login', component: SignupComponent }, { path: 'about', component: AboutComponent }
];



export const Routing: ModuleWithProviders = RouterModule.forRoot(routes);




// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.routes.ts